module.exports = __webpack_public_path__ + "img/vip.c1f33efd.svg";